import { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import moment from "moment";
import { connect } from "react-redux";
import Pagination from "../../../utils/pagination";
import { toastError, centerActionId, organizersActionId, orderStatusActionId, sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
import DatePicker from 'react-datepicker';
import { fill_action } from "../../../actions/fillList_action"
import Workbook from 'react-excel-workbook'
import Header from '../../../common_components/Header';
import { get_order_report_action } from "../../../actions/report_action/report_action";
class subReport1 extends Component {
    // intialize constructor
    constructor(props) {
        super(props)
        this.state = {
            reportName: '',
            reportID: '',
            venueList: [],
            venueId: '',
            venueName: '',
            orgenizersList: [],
            organiserId: '',
            organizerName: '',
            orderStatusList: [],
            orderStatusId: '',
            orderStatusName: '',
            isLoading: false,
            showTable: false,
            isAccordionExpanded: false,
            startDate: '',
            endDate: "",
            list: [],
            columnArr: [],
            rowArr: [],
            xlrowArr: [],
            currentPage: 1,
            PiShow: false,
        }

        this.onViewClick = this.onViewClick.bind(this)
        this.renderTable = this.renderTable.bind(this)
        this.onDownloadClick = this.onDownloadClick.bind(this)
        this.getFillList = this.getFillList.bind(this)
        // this.getExhibitorDetailsReportlist = this.getExhibitorDetailsReportlist.bind(this)
        // this.reportIdCondition = this.reportIdCondition.bind(this)
        this.onChangeInputFields = this.onChangeInputFields.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.handleback = this.handleback.bind(this)

    }

    componentDidMount() {
        // this.getExhibitionManualForm()
        this.getFillList(centerActionId, '')
        this.getFillList(organizersActionId, '')
        this.getFillList(orderStatusActionId, '')


        // this.getFillList(exhibitorNameActionId, '', '', '', '', '')
        this.setState({
            reportName: this.props.location.state != null && this.props.location.state.reportName != null ? this.props.location.state.reportName : '',
            reportID: this.props.location.state != null && this.props.location.state.reportID != null ? this.props.location.state.reportID : '',
        })
        setTimeout(() => {

            console.log(this.state.reportName)
        }, 100);
    }

    getFillList(value, userID) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(value, (userID == '' || userID == null) ? null : userID)
            .then((data) => {
                if (data.error != 1) {
                    if (value == centerActionId) {
                        var list = []
                        for (var i = 0; i < data.data.length; i++) {
                            if (data.data[i].ParentCenterID == 0) {
                                list.push(data.data[i])
                            }
                        }
                        // console.log(list)

                        this.setState({ venueList: list, isLoading: false })
                    }
                    if (value == organizersActionId) {
                        console.log(data.data)

                        this.setState({ orgenizersList: data.data, isLoading: false })
                    }
                    if (value == orderStatusActionId) {
                        console.log(data.data)

                        this.setState({ orderStatusList: data.data, isLoading: false })
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    // reportIdCondition(status, value) {
    //     const { reportID } = this.state
    //     if (reportID == 2) {
    //         this.getExhibitorDetailsReportlist(status, value)
    //     }
    //     if (reportID == 3) {
    //         this.getReceiptReportlist(status, value)
    //     }
    //     if (reportID == 4) {
    //         this.getTaxInvoiceReportlist(status, value)
    //     }
    // }

    onChangeInputFields(status, value) {
        console.log(status, value)
        if (status == 'venue') {
            if (value == 'Select') {
                this.setState({ venueName: null })
                this.setState({ venueId: null })
            }
            else if (value == 'All') {
                this.setState({ venueName: 'All' })
                this.setState({ venueId: null })
            }
            else {
                this.setState({ venueId: value })
                this.state.venueList.map((data) => {
                    if (data.CenterID == value) {
                        this.setState({ venueName: data.Name })
                    }
                })
            }
        }
        if (status == 'orderStatus') {
            if (value == 'Select') {
                this.setState({ orderStatusName: null })
                this.setState({ orderStatusId: null })
            }
            else if (value == 'All') {
                this.setState({ orderStatusName: 'All' })
                this.setState({ orderStatusId: null })
            }
            else {
                this.setState({ orderStatusId: value })
                this.state.orderStatusList.map((data) => {
                    if (data.ID == value) {
                        this.setState({ orderStatusName: data.DeliveryStatus })
                    }
                })
            }
        }
        if (status == 'organiser') {
            if (value == 'Select') {
                this.setState({ organizerName: null })
                this.setState({ organiserId: null })
            }
            else if (value == 'All') {
                this.setState({ organizerName: 'All' })
                this.setState({ organiserId: null })
            }
            else {
                this.setState({ organiserId: value })
                this.state.orgenizersList.map((data) => {
                    if (data.ClientID == value) {
                        this.setState({ organizerName: data.CompanyName })
                    }
                })
            }
        }
        if (status == 'fromDate') {
            this.setState({ startDate: value })
        }
        if (status == 'toDate') {
            this.setState({ endDate: value })
        }
        setTimeout(() => {
            if (this.state.startDate != '' && this.state.startDate != null && this.state.endDate != '' && this.state.endDate != null) {
                this.getOrderReportlist()
            }
        }, 200);
    }

    getOrderReportlist() {
        const { startDate, endDate, venueId, orderStatusId, organiserId } = this.state
        this.setState({ isLoading: true })
        this.props.get_order_report_action(startDate, endDate, venueId, orderStatusId, organiserId)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    // data.data.map((element) =>
                    //     delete element['ADDITIONAL BADGES'])
                    this.setState({ list: data.data })
                    // if (status == 'view') {
                    this.getTableData(data.data)
                    this.setState({ showTable: false })
                    // }
                    // else if (status == 'download') {
                    //     this.onDownloadClick(data.data)
                    //     this.setState({ isLoading: false })
                    // }
                    this.setState({ isLoading: false })

                }
                else {
                    if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                          toastError(data.msg, {
                            position:"top-center",
                            theme: "colored",
                            autoClose: 3000,
                            hideProgressBar: true,
                          });
                        }, 500);
                    }else{
                    this.setState({ isLoading: false })
                    toastError(data.msg)}
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    onViewClick() {
        const { startDate, endDate } = this.state
        console.log(this.state.list)
        if (startDate == '' || startDate == null || endDate == '' || endDate == null) {
            toastError('Please select From and To Dates')
        }
        else {
            this.setState({ showTable: true })
        }
    }

    getTableData(list) {
        const { } = this.state
        // for column data 
        var columnArray = []
        var rowData = []
        console.log('columnArray', list);

        list.map((data, index) => {
            if (index == 0) {
                console.log('columnArray', data, Object.keys);

                Object.keys(data).map((key, index) => {

                    columnArray.push(key)
                })
            }
        })
        this.setState({ columnArr: columnArray })
        console.log('columnArray', columnArray);
        var xlRowdata = []
        // // for row data
        list.map((data, index) => {
            rowData.push(Object.values(data))
            xlRowdata.push(data)
        })
        this.setState({ rowArr: rowData })
        this.setState({ xlrowArr: xlRowdata })
        setTimeout(() => {

            console.log(rowData, xlRowdata)
        }, 500);

        // this.renderTable()
        // if (listName == 'SLA_BreachList') {
        //     console.log("onReset 12", list)

        //     this.setState({
        //         SLA_BreachRowData: rowData,
        //         SLA_BreachColumnArray: columnArray,
        //         temp_SLA_BreachRowData: rowData,
        //     })
        //     columnArray = []
        //     rowData = []
        //     console.log("onReset 12 original_SLA_BreachRowData", original_SLA_BreachRowData)
        //     setTimeout(() => {
        //         this.getClientList()
        //     }, 300);
        // }
        // if (listName == 'original_SLA_BreachList') {
        //     console.log("onReset 12 original_SLA_BreachList", list)
        //     this.setState({
        //         original_SLA_BreachRowData: rowData,
        //         SLA_BreachRowData: rowData
        //     })
        //     columnArray = []
        //     rowData = []
        //     console.log("onReset 12 original_SLA_BreachRowData", original_SLA_BreachRowData)

        // }
    }

    onDownloadClick() {
        const { list, columnArr, rowArr, reportName, startDate, endDate } = this.state
        if (startDate == '' || startDate == null || endDate == '' || endDate == null) {
            toastError('Please select From and To Dates')
        }
        else {
            this.setState({ showTable: true })
            return (
                <div className="row text-center">
                    {list.length > 0 && <Workbook filename={`order_report.xlsx`} style={{}} element={
                        <button type="button" className="btn ad-fil-btn m-0" >
                            download
                        </button>
                    }>
                        <Workbook.Sheet data={list} name="Sheet A">
                            {columnArr.map((value, index) =>
                                <Workbook.Column label={value} value={value} />
                            )
                            }
                        </Workbook.Sheet>
                    </Workbook>}
                </div>
            );
        }

    }

    renderTable(currentList) {
        const { columnArr, rowArr } = this.state
        console.log('k')
        return (
            <>
                <div className="table-responsive mb-4">
                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                        <thead> <tr>
                            {/* <th><input type="checkbox" key={Math.random()} defaultChecked={isAllCheck} onClick={() => this.allCheckClick(!isAllCheck)} /></th> */}
                            {
                                columnArr.length > 0 && columnArr.map((data, index) => (
                                    <>  {(<th>{data}</th>)}</>
                                ))
                            }    </tr>

                        </thead>

                        <tbody>
                            {
                                currentList.length > 0 ?
                                    currentList.map((data, i) => (
                                        <tr key={i}>
                                            {/* <td><input type="checkbox" key={Math.random()} defaultChecked={data[data.length - 1]} onClick={() => this.onSelectCheckClick(data[data.length - 2], !data[data.length - 1])} /></td> */}
                                            {data != null && data != '' && data.map((element, index) => (
                                                <>
                                                    <td>{element}
                                                    </td></>

                                            ))}
                                        </tr>
                                    )) : <tr><td colSpan={3} style={{ textAlign: 'center' }}>Record not found</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </>
        )
    }

    updateItem(item) {
        console.log("updateItem : ", item);
        this.setState({ currentPage: item });
    }
    handleback() {
        this.props.navigate("/reportList",)
    }

    render() {
        const { isLoading, orderStatusId, orderStatusList, PiShow, venueList, organiserId, orgenizersList, venueId, startDate, endDate, reportID, reportName, rowArr, isAccordionExpanded, showTable, xlrowArr, columnArr, list, currentPage } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = rowArr.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(rowArr.length / recordsPerPage);
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <main id="main">
                    <Header data={[8]} />
                    <section style={{ marginTop: '115px' }}>
                        <div className="container-fluid">
                            <div className="page-header ml-2">
                                <h4 className="page-title">Order Report</h4>
                            </div>
                            <div className="search_accordion search_card">
                                <div className="panel-group" id="accordion">
                                    <div className="panel panel-default">
                                        <div
                                            className="panel-heading accordion-toggle collapsed"
                                            data-toggle="collapse"
                                            data-parent="#accordion"
                                            data-target="#collapseOne"
                                            aria-expanded={isAccordionExpanded}
                                            onClick={() =>
                                                this.setState({
                                                    isAccordionExpanded: !isAccordionExpanded,
                                                })
                                            }
                                        >
                                            <h4 className="panel-title">Search</h4>
                                            <div className="searched_items">
                                                <h5>
                                                    From Date :{" "}
                                                    {this.state.startDate != '' && this.state.startDate != null &&
                                                        <span>
                                                            {moment(startDate).format('DD-MM-YYYY')}
                                                        </span>}
                                                </h5>
                                                <h5>
                                                    To Date :{" "}
                                                    {this.state.endDate != '' && this.state.endDate != null &&
                                                        <span>
                                                            {moment(endDate).format('DD-MM-YYYY')}
                                                        </span>}
                                                </h5>
                                                {this.state.venueName != '' && this.state.venueName != null &&
                                                    <h5>
                                                        Center Name : <span>{this.state.venueName}</span>
                                                    </h5>}
                                                {this.state.organizerName != '' && this.state.organizerName != null &&
                                                    <h5>
                                                        Organizer : <span>{this.state.organizerName}</span>
                                                    </h5>}
                                                {this.state.orderStatusName != '' && this.state.orderStatusName != null &&
                                                    <h5>
                                                        Status : <span>{this.state.orderStatusName}</span>
                                                    </h5>}
                                                {/* <div class="chip">
              John Doe <span class="closebtn" onclick="this.parentElement.style.display='none'">&times;</span>
            </div> */}
                                            </div>
                                        </div>
                                        <div
                                            id="collapseOne"
                                            className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                                                }`}
                                            aria-labelledby="headingOne"
                                        >
                                            <div className="panel-body">
                                                <div className="row mr_0">
                                                    <div className="col-md-2 ml-4">
                                                        <div className="form-group">
                                                            <label>From Date<span style={{ color: 'red' }} className="text-red">*</span></label>
                                                            <DatePicker className={"form-control text-dark"}
                                                                // dateFormat="dd-MM-yyyy"
                                                                // disabled={statusId != 2 && is_update == true ? true : false}
                                                                // selected={this.state.toDate}
                                                                // minDate={this.state.fromDate == '' || this.state.fromDate == null ? this.state.minDate : this.state.fromDate}
                                                                // onChange={(date) => {
                                                                //     this.setState({ toDate: date });

                                                                // }}
                                                                dateFormat="dd-MM-yyyy"
                                                                // disabled={statusId != 2 && is_update == true ? true : false}
                                                                selected={startDate}
                                                                onChange={(date) => {
                                                                    this.onChangeInputFields('fromDate', date)
                                                                }}
                                                                maxDate={endDate}
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="From Date"
                                                            // customInput={<ExampleCustomInput />}
                                                            // dayClassName={() => "example-datepicker-day-class"}
                                                            // popperClassName="example-datepicker-class"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 ml-4">
                                                        <div className="form-group">
                                                            <label>To Date<span style={{ color: 'red' }} className="text-red">*</span></label>
                                                            <DatePicker className={"form-control text-dark"}
                                                                // dateFormat="dd-MM-yyyy"
                                                                // disabled={statusId != 2 && is_update == true ? true : false}
                                                                // selected={this.state.toDate}
                                                                // minDate={this.state.fromDate == '' || this.state.fromDate == null ? this.state.minDate : this.state.fromDate}
                                                                // onChange={(date) => {
                                                                //     this.setState({ toDate: date });

                                                                // }}
                                                                dateFormat="dd-MM-yyyy"
                                                                // disabled={statusId != 2 && is_update == true ? true : false}
                                                                selected={endDate}
                                                                onChange={(date) => {
                                                                    this.onChangeInputFields('toDate', date)
                                                                }}
                                                                minDate={startDate}
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="To Date"
                                                            // customInput={<ExampleCustomInput />}
                                                            // dayClassName={() => "example-datepicker-day-class"}
                                                            // popperClassName="example-datepicker-class"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 ml-4">
                                                        <div className="form-group">
                                                            <label>Center</label>
                                                            <select
                                                                className="form-control"
                                                                value={venueId}
                                                                onChange={(e) => {
                                                                    this.onChangeInputFields('venue', e.target.value)
                                                                }}
                                                            >
                                                                <option>Select</option>
                                                                <option>All</option>
                                                                {venueList.length > 0 ? venueList.map(data => (
                                                                    <option
                                                                        key={data.CenterID}
                                                                        value={data.CenterID}>
                                                                        {data.Name}
                                                                    </option>
                                                                )) : <></>}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label>Organizer</label>
                                                            <select
                                                                className="form-control"
                                                                value={organiserId}
                                                                onChange={(e) => {
                                                                    this.onChangeInputFields('organiser', e.target.value)
                                                                }}
                                                            >
                                                                <option>Select</option>
                                                                <option>All</option>
                                                                {orgenizersList.length > 0 ? orgenizersList.map(data => (
                                                                    <option
                                                                        key={data.ClientID}
                                                                        value={data.ClientID}>
                                                                        {data.CompanyName}
                                                                    </option>
                                                                )) : <></>}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label>Order Status</label>
                                                            <select
                                                                className="form-control"
                                                                value={orderStatusId}
                                                                onChange={(e) => {
                                                                    this.onChangeInputFields('orderStatus', e.target.value)
                                                                }}
                                                            >
                                                                <option>Select</option>
                                                                <option>All</option>
                                                                {orderStatusList.length > 0 ? orderStatusList.map(data => (
                                                                    <option
                                                                        key={data.ID}
                                                                        value={data.ID}>
                                                                        {data.DeliveryStatus}
                                                                    </option>
                                                                )) : <></>}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row m-2" style={{ float: 'right', right: '0px' }}>
                                <div className="btn-group save-can d-block" role="group" aria-label="Basic example">
                                    <button
                                        type="button"
                                        className="btn btn-warning my_custom_orderPage_btns m-2"
                                        style={{ width: 140, fontSize: 15, }}
                                        onClick={this.onViewClick}
                                    >
                                        View
                                    </button>
                                    {list.length > 0 ? <Workbook filename={`order_report.xlsx`} style={{}} element={
                                        <button className="btn btn-success my_custom_orderPage_btns m-2" style={{ width: 140, fontSize: 15 }} >
                                            download
                                        </button>
                                    }>
                                        <Workbook.Sheet data={xlrowArr} name="Sheet A">
                                            {columnArr.map((value, index) =>
                                                <Workbook.Column label={value} value={value} />
                                            )
                                            }
                                        </Workbook.Sheet>
                                    </Workbook>
                                        : <button className="btn btn-success my_custom_orderPage_btns m-2" style={{ width: 140, fontSize: 15 }} disabled={true}>
                                            download
                                        </button>
                                    }
                                    <button onClick={this.handleback} className="btn btn-primary my_custom_orderPage_btns m-2" style={{ width: 140, fontSize: 15 }} >
                                        back
                                    </button>
                                </div>
                            </div>
                            {showTable && this.renderTable(currentRecords)}
                            {showTable && rowArr.length > 0 ? (
                                <Pagination
                                    nPages={nPages}
                                    currentPage={currentPage}
                                    setCurrentPage={this.updateItem}
                                />
                            ) : (
                                <></>
                            )}
                        </div>
                    </section>
                </main>
                {/* <Modal
                    show={PiShow}
                    // onHide={this.piModalClose}
                    size="md"
                >
                    <Modal.Header>
                        <Modal.Title>
                            Proforma Invoice for Order: {OrderNo}
                        </Modal.Title>
                        <span
                            onClick={() => this.piModalClose()}
                            style={{
                                cursor: "pointer",
                                fontWeight: "800",
                            }}
                        >
                            X
                        </span>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="form-group">
                            <h5>Proforma Invoice List</h5>
                            <table className="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">Sr.No</th>
                                        <th scope="col">
                                            Proforma Invoice No.
                                        </th>
                                        <th scope="col">
                                            Proforma Invoice Type
                                        </th>
                                        <th scope="col">Download</th>
                                    </tr>
                                </thead>
                                <tbody id="show_proformainvoices">
                                    {proformaList.length > 0 ? (proformaList.map((data, i) => (
                                        <tr key={data.ProformaInvoiceID}>
                                            <td colSpan="">{i + 1}</td>
                                            <td>{data.ProformaInvoice_No}</td>
                                            <td>
                                                {data.ProformaType ===
                                                    "Additionalservices"
                                                    ? data.ProformaType
                                                    : "Rental"}
                                            </td>
                                            <td>
                                                <a
                                                    title="Download Proforma"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() =>
                                                        this.downloadPerformaInvoice(
                                                            data.ProformaInvoiceID,
                                                            data.ProformaInvoice_No
                                                        )
                                                    }
                                                >
                                                    <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                                                </a>
                                            </td>
                                        </tr>
                                    ))) : (
                                        <tr>
                                            <td colSpan="4">No Proforma Details Found!</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            variant="success"
                            onClick={() => this.piModalClose()}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal> */}
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, get_order_report_action })(subReport1))